// src/features/agent-builder/components/WelcomeBotTeaser.tsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Tooltip } from '@dopomogai/ui';
import { renderIcon } from '@dopomogai/utils'; // Assuming this is your icon utility

export const WelcomeBotTeaser: React.FC = () => {
  const { t } = useTranslation('agentBuilder');

  return (
    <div className="mt-6 p-4 bg-sky-50 border border-sky-200 rounded-lg">
      <div className="flex items-start gap-3">
        <div className="shrink-0 pt-0.5 text-sky-600">
          {renderIcon('message', { size: 24 })} {/* 'message' or 'messagesquare' from your mapping */}
        </div>
        <div>
          <h4 className="text-md font-semibold text-sky-800">
            {/* i18n: agentBuilder.step4.welcomeBot.title = "WelcomeBot Assistant" */}
            {t('step4.welcomeBot.title')}
          </h4>
          <p className="mt-1 text-sm text-sky-700 leading-relaxed">
            {/* i18n: agentBuilder.step4.welcomeBot.description = "Let WelcomeBot suggest smart, context-aware welcome messages. It can even help your agent proactively offer assistance on different pages!" */}
            {t('step4.welcomeBot.description')}
          </p>
          <div className="mt-3 flex flex-col sm:flex-row gap-2">
            <Tooltip
              textKey="agentBuilder:step4.welcomeBot.suggestTooltip"
              // text={t('step4.welcomeBot.suggestTooltip')} // "Get AI-generated welcome message ideas..."
            >
              <Button
                textKey="agentBuilder:step4.welcomeBot.suggestButton"
                // text={t('step4.welcomeBot.suggestButton')} // "[✨ AI: Suggest Welcome Message (Coming Soon)]"
                variant="secondary" // Or a specific teaser style
                size="sm"
                disabled
                icon={renderIcon('sparkles', { size: 14 })}
                className="opacity-70 cursor-not-allowed border-sky-300 text-sky-700 hover:border-sky-400"
              />
            </Tooltip>
            <Tooltip
              textKey="agentBuilder:step4.welcomeBot.enableSmartTooltip"
              // text={t('step4.welcomeBot.enableSmartTooltip')} // "Allow WelcomeBot to dynamically change messages..."
            >
              <Button
                textKey="agentBuilder:step4.welcomeBot.enableSmartButton"
                // text={t('step4.welcomeBot.enableSmartButton')} // "[✨ AI: Enable Smart Welcome (Coming Soon)]"
                variant="secondary"
                size="sm"
                disabled
                icon={renderIcon('zap', { size: 14 })} // 'zap' or 'rocket' for "smart"
                className="opacity-70 cursor-not-allowed border-sky-300 text-sky-700 hover:border-sky-400"
              />
            </Tooltip>
          </div>
        </div>
      </div>
    </div>
  );
};